import { sumBy } from 'lodash';
import T from 'prop-types';
import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import WhiteContainer from '../../../components/containers/WhiteContainer';
import { getAddOnConfig } from '../../../components/mapView/drawingManager/utilities';
import { MapViewContext } from '../../../components/mapView/mapViewContext';
import { BUY_NOW_DATA_TYPES, PRODUCT_TYPE, RFQ_DATA_TYPES, SMART_SELECTION_DELIVERY_METHOD } from '../../../constants/product';
import text, { formatCurrency } from '../../../text';
import { isMembershipPriceId } from '../../../utilities/membership';
import { isStaff, userHasActiveMembership } from '../../../utilities/user';
var ForQuotation = function(param) {
    var _param_numOrder = param.numOrder, numOrder = _param_numOrder === void 0 ? 0 : _param_numOrder;
    var _useContext = useContext(MapViewContext), buyNowData = _useContext.state.buyNowData;
    var _useSelector = useSelector(function(state) {
        var _state_jobsReducer_job;
        return {
            quote: (_state_jobsReducer_job = state.jobsReducer.job) === null || _state_jobsReducer_job === void 0 ? void 0 : _state_jobsReducer_job.quote,
            membershipPriceId: state.order.membershipPriceId,
            currentUser: state.profileReducer.userProfile
        };
    }), quote = _useSelector.quote, membershipPriceId = _useSelector.membershipPriceId, currentUser = _useSelector.currentUser;
    var currency = quote === null || quote === void 0 ? void 0 : quote.currency;
    var hasSelectedMembership = isMembershipPriceId(membershipPriceId);
    var isMember = hasSelectedMembership && !isStaff(currentUser.role) || userHasActiveMembership(currentUser);
    var siteDeploymentFee = useMemo(function() {
        var fee = quote === null || quote === void 0 ? void 0 : quote.fees.find(function(fee) {
            return fee.id === 'site_deployment_fee';
        });
        return (fee === null || fee === void 0 ? void 0 : fee.price.total) || 0;
    }, [
        quote === null || quote === void 0 ? void 0 : quote.fees
    ]);
    var quotableItems = useMemo(function() {
        var _quote_charges, _quote_charges1, _quote_charges2;
        var _quotableItems = [];
        var buyNowTypeContainsUnknown = quote === null || quote === void 0 ? void 0 : (_quote_charges = quote.charges) === null || _quote_charges === void 0 ? void 0 : _quote_charges.some(function(param) {
            var details = param.details;
            return [
                PRODUCT_TYPE.UNKNOWN
            ].includes(details.delivery_method) && BUY_NOW_DATA_TYPES.includes(details.category_name);
        });
        if (buyNowTypeContainsUnknown) {
            _quotableItems.push(text('tbcBuyNowDataInDatabase'));
        }
        var chargesContainsManual = quote === null || quote === void 0 ? void 0 : (_quote_charges1 = quote.charges) === null || _quote_charges1 === void 0 ? void 0 : _quote_charges1.some(function(param) {
            var details = param.details;
            return [
                SMART_SELECTION_DELIVERY_METHOD.MANUAL
            ].includes(details.delivery_method) || RFQ_DATA_TYPES.includes(details.category_name);
        });
        if (chargesContainsManual) {
            _quotableItems.push(text('getQuote3dScanCaptureServices'));
        }
        var chargesContainsAddOns = quote === null || quote === void 0 ? void 0 : (_quote_charges2 = quote.charges) === null || _quote_charges2 === void 0 ? void 0 : _quote_charges2.some(function(param) {
            var details = param.details;
            return !!getAddOnConfig(details.category_name);
        });
        if (chargesContainsAddOns) {
            _quotableItems.push(text('addOns'));
        }
        return _quotableItems;
    }, [
        quote === null || quote === void 0 ? void 0 : quote.charges
    ]);
    var chargesHasTbc = useMemo(function() {
        var _quote_charges;
        return quote === null || quote === void 0 ? void 0 : (_quote_charges = quote.charges) === null || _quote_charges === void 0 ? void 0 : _quote_charges.some(function(param) {
            var details = param.details;
            return [
                PRODUCT_TYPE.UNKNOWN
            ].includes(details.delivery_method);
        });
    }, [
        quote === null || quote === void 0 ? void 0 : quote.charges
    ]);
    var getQuoteTotal = useMemo(function() {
        if (chargesHasTbc) {
            return text('toBeConfirmed');
        }
        return sumBy((quote === null || quote === void 0 ? void 0 : quote.charges) || [], function(charge) {
            var isManualOrUnknown = [
                PRODUCT_TYPE.UNKNOWN,
                SMART_SELECTION_DELIVERY_METHOD.MANUAL
            ].includes(charge.details.delivery_method);
            if (isManualOrUnknown) {
                var _charge_price, _charge_price1;
                var chargeTotal = isMember ? (_charge_price = charge.price) === null || _charge_price === void 0 ? void 0 : _charge_price.member_total : (_charge_price1 = charge.price) === null || _charge_price1 === void 0 ? void 0 : _charge_price1.total;
                return chargeTotal || 0;
            }
            return 0;
        }) + (siteDeploymentFee || 0);
    }, [
        chargesHasTbc,
        isMember,
        quote === null || quote === void 0 ? void 0 : quote.charges,
        siteDeploymentFee
    ]);
    if (quotableItems.length <= 0) {
        return null;
    }
    if (!quote) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, buyNowData.length > 0 && /*#__PURE__*/ React.createElement("hr", {
        className: "quote-divider"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row align-align-items-center mb-3 get-quote-section justify-content-between"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-uppercase font-16 grey-3 font-weight--600 mb-0"
    }, text('getQuote'), ":"), /*#__PURE__*/ React.createElement("p", {
        className: "mb-0 text-right font--14 total"
    }, getQuoteTotal > 0 ? "~".concat(formatCurrency(getQuoteTotal, currency.name, currency.scale_factor, {}, true)) : 'TBC')), /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "Invoice"
    }, quotableItems.map(function(headerName, index) {
        return /*#__PURE__*/ React.createElement("h6", {
            className: "grey-3 font-weight--600 mb-0 my-2",
            key: index
        }, /*#__PURE__*/ React.createElement("span", {
            className: "mr-1"
        }, numOrder + (index + 1), "."), ' ', /*#__PURE__*/ React.createElement("span", null, headerName));
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("h6", {
        className: "grey-3 mb-0 py-2 font-weight--400 pl-3 rfq-note text-justify",
        style: {
            lineHeight: '140%'
        }
    }, /*#__PURE__*/ React.createElement("span", {
        key: "rfq-note"
    }, text('invoiceRfqNote', {
        contact: /*#__PURE__*/ React.createElement("a", {
            className: "d-inline",
            href: "".concat(process.env.LARKI_MARKETING_URL, "/contact-us"),
            target: "_blank",
            rel: "noreferrer"
        }, "contact LARKI")
    }))))));
};
ForQuotation.propTypes = {
    numOrder: T.number
};
export default ForQuotation;
